const Gst = {
  TAX_TYPE: {
    non_gta: 1, //FCM
    gta: 2, //RCM
  },
  REVERSE_TO_FORWARD: {
    igst_tax: 12,
    state_tax: 6,
    central_tax: 6,
  },
  NON_GTA: { // 1
    igst_tax: 18,
    state_tax: 9,
    central_tax: 9,
  },
  GTA: { // 2
    igst_tax: 5,
    state_tax: 2.5,
    central_tax: 2.5,
  },
  PAID_TO: {
    vendor: 1,
    government: 2,
  },
  TRANSPORTER_NON_GST: {
    igst_tax: [12, 18],
  },
};

module.exports = { Gst };
